import { NGDatabase } from './NGDatabase';
export class NGDatabaseCommon extends NGDatabase {
    constructor() {
        super(...arguments);
        this.common = new NGDatabase();
    }
    init(prefix, firestore) {
        super.init(prefix, firestore);
        this.common.init('/common', firestore);
    }
}
//# sourceMappingURL=NGDatabaseCommon.js.map